import { OpeningHourKind } from "@/graphql/graphql"
import { WEEKDAYS, DEFAULT_START_TIME, DEFAULT_END_TIME } from "./constants"

export interface RegularHour {
  id?: string
  weekday: number
  closed: boolean
  startTime: string
  endTime: string
}

export interface SpecialHour {
  id?: string
  closed: boolean
  startDate: string
  endDate: string
  startTime: string
  endTime: string
}

export interface FormValues {
  regularHours: RegularHour[]
  specialHours: SpecialHour[]
}

export interface OpeningHour {
  id: string
  kind?: OpeningHourKind | null
  weekday?: number | null
  closed?: boolean | null
  startTime?: string | null
  endTime?: string | null
  startDate?: string | null
  endDate?: string | null
}

export const getInitialValues = (openingHours?: OpeningHour[]): FormValues => {
  if (!openingHours) {
    return {
      regularHours: WEEKDAYS.map((day) => ({
        weekday: day.value,
        closed: true,
        startTime: DEFAULT_START_TIME,
        endTime: DEFAULT_END_TIME,
      })),
      specialHours: [],
    }
  }

  const regularHours = WEEKDAYS.map((day) => {
    const existing = openingHours.find((h) => h.kind === OpeningHourKind.Regular && h.weekday === day.value)
    return {
      id: existing?.id,
      weekday: day.value,
      closed: existing?.closed ?? true,
      startTime: existing?.startTime || DEFAULT_START_TIME,
      endTime: existing?.endTime || DEFAULT_END_TIME,
    }
  })

  const specialHours = openingHours
    .filter((h) => h.kind === OpeningHourKind.Special)
    .map((h) => ({
      id: h.id,
      closed: h.closed ?? false,
      startDate: h.startDate || "",
      endDate: h.endDate || "",
      startTime: h.startTime || DEFAULT_START_TIME,
      endTime: h.endTime || DEFAULT_END_TIME,
    }))

  return { regularHours, specialHours }
}
